import { render, staticRenderFns } from "./changeTel.vue?vue&type=template&id=5765c82a"
import script from "./changeTel.vue?vue&type=script&lang=js"
export * from "./changeTel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports